import React from 'react';
import { Doughnut } from 'react-chartjs-2';
import { useTranslation } from 'react-i18next';
import { ReactComponent as IconSatis } from '../../../../assets/icons/u_alert-check.svg';
import { ReactComponent as IconExcl } from '../../../../assets/icons/u_alert-exclamacion.svg';
import { ReactComponent as IconMult } from '../../../../assets/icons/u_alert-multyple.svg';
import { ReactComponent as IconNoAsg } from '../../../../assets/icons/u_alert-not-assigned.svg';

export const gradientColors = ['#6DD983', '#EF9206', '#F06D6D', '#D0D5E0', '#ffd700'];

const iconLabels = [<IconSatis />, <IconExcl />, <IconMult />, <IconNoAsg />];
const labels = ['Satisfactorio', 'Alerta', 'Problemas', 'N/A'];

export const OnePagerDoughnutChart = ({ data }) => {
  const { t } = useTranslation();

  const labels = [
    t('one_pager_report.satisfactory'),
    t('one_pager_report.alert'),
    t('one_pager_report.problems'),
    'N/A',
  ];

  const doughnutChartSetting = {
    labels: labels,
    datasets: [
      {
        data: data.map(item => item.percent),
        backgroundColor: gradientColors,
        hoverBackgroundColor: gradientColors,
      },
    ],
  };

  const doughnutChartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    cutoutPercentage: 75,
    tooltips: {
      displayColors: false,
      backgroundColor: '#101319',
      titleFontSize: 14,
      bodyFontSize: 14,
      callbacks: {
        title: (tooltipItem, data) => {
          return t(data['labels'][tooltipItem[0]['index']]);
        },
        label: (tooltipItem, data) => {
          return `${data['datasets'][0]['data'][tooltipItem['index']].toFixed(0)} %`;
        },
      },
    },
    legend: {
      display: false,
    },
    plugins: {
      datalabels: { display: false },
    },
    animation: {
      duration: true ? 0 : 1000,
    },
  };

  return (
    <div className="c-doughnut">
      <div className="c-doughnut-chart-labels">
        {data.map((item, index) => (
          <DoughnutChartLabels key={index} status={index} projects={item.projectCount} percent={item.percent} />
        ))}
      </div>

      <div className="chart">
        <Doughnut data={doughnutChartSetting} options={doughnutChartOptions} />
      </div>
    </div>
  );
};

const DoughnutChartLabels = ({ status, projects, percent }) => {
  const { t } = useTranslation();
  const labels = [
    t('one_pager_report.satisfactory'),
    t('one_pager_report.alert'),
    t('one_pager_report.problems'),
    'N/A',
  ];
  return (
    <div className="c-chart-label-content">
      <div className="label-status">
        {iconLabels[status]} <span>{labels[status]}</span>
      </div>
      <div className="label-projects">
        {projects} {t('one_pager_report.projects')}
      </div>
      <div className="label-percent">{percent} %</div>
    </div>
  );
};
